import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { PermissionFacade } from './facades/permission.facade';
import { PermissionSetModule } from './permission-container/permission-set/permission-set.module';
import { RolePermissionModule } from './permission-container/role-permission/role-permission.module';
import { TeamPermissionModule } from './permission-container/team-permission/team-permission.module';
import { UserPermissionModule } from './permission-container/user-permission/user-permission.module';
import { ClientSidePermissionSetModule } from './permission-container/client-side-permission/client-side-permission.module';
import { permissionsViewCacheReducers } from './view-cache-controller/store/reducers/root';
import { permissionViewCacheFeatureKey } from './view-cache-controller/store/reducers/view-cache.reducers';
import { FieldConfigurationModule } from './field-configuration/field-configuration.module';
import { PermissionWizardModule } from './permission-container/permission-wizard/permission-wizard.module';
import { RolePricingSchemeLinkModule } from './permission-container/role-pricing-scheme-link/role-pricing-scheme-link.module';
import { AppletAuditTrailModule } from '../settings/developer-tools/applet-audit-trail/applet-audit-trail.module';

export const permissionCacheStoreModule = StoreModule.forFeature(permissionViewCacheFeatureKey, permissionsViewCacheReducers.permissionViewCache);

@NgModule({
  imports: [
    CommonModule,
    PermissionSetModule,
    PermissionWizardModule,
    UserPermissionModule,
    TeamPermissionModule,
    RolePermissionModule,
    ClientSidePermissionSetModule,
    FieldConfigurationModule,
    RolePricingSchemeLinkModule,
    AppletAuditTrailModule,
    permissionCacheStoreModule
  ],
  providers: [
    PermissionFacade
  ]
})
export class PermissionViewCacheModule {}
